import React, { useContext, useEffect, useState } from 'react';

import {
	Typography,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Container,
	Stack
} from '@mui/material';
import moment from 'moment';
import { getDataNotificacionAsync } from '../../../../api/Credits';
import { getToken } from '../../../../api/Account';
import { simpleMessage } from '../../../../helpers/Helpers';
import { DataContext } from '../../../../context/DataContext';
import './notification.css';

export const PrintNotificacionCobro = React.forwardRef((props, ref) => {
	const [data, setData] = useState([]);
	const { title, slogan, icon, setIsLoading, setIsUnautorized } = useContext(DataContext);
	const { id } = props;
	const token = getToken();

	const getPageMargins = () => {
		return `body {
              color:black;
            }`;
	};

	useEffect(() => {
		getDataCredit();
	}, []);

	const getDataCredit = async () => {
		setIsLoading(true);
		const result = await getDataNotificacionAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		setData(result.data.result);
		setIsLoading(false);
	};

	return (
		<div ref={ref}>
			<style>{getPageMargins()}</style>

			{data.length === 0 ? null : (
				<>
					<Stack direction="row" justifyContent="space-between">
						<img src={icon} style={{ width: 70, height: 70 }} />
						<Stack>
							<Typography variant="h5" color="#212121" textAlign={'center'}>
								{title}
							</Typography>
							<Typography color="#212121" textAlign={'center'}>
								{slogan}
							</Typography>
						</Stack>
						<img src={icon} style={{ width: 70, height: 70 }} />
					</Stack>

					<hr />

					<div className="notification-header">
						<h6>NOTIFICACION DE COBRO</h6>
					</div>

					<div className="recipient">
						<h6>
							{data.sex === 'MASCULINO' ? 'Sr. ' : 'Sra. '} {data.fullName}
						</h6>
					</div>

					<div className="content">
						<p>Estimado cliente.</p>

						<p>
							Por este medio nos dirigimos a usted, para notificarle que su obligación
							crediticia con nosotros se encuentra pendiente de pago, presentando
							<strong>
								{' '}
								{new Intl.NumberFormat('es-NI', {
									style: 'currency',
									currency: 'NIO'
								}).format(data.atraso)}
							</strong>{' '}
							de saldo <strong>Vencido</strong> con <strong>{data.atrasoDias}</strong>{' '}
							días de Mora al día de hoy, equivalente a{' '}
							<strong>{data.cuotasAtrasadas}</strong>{' '}
							{data.cuotasAtrasadas > 1 ? 'cuotas' : 'cuota'} y un{' '}
							<strong>{data.porcentaje} %</strong> del saldo actual de su crédito, el
							cual no ha sido honrado por su parte como debe ser, solicitamos su
							colaboración y su responsabilidad para poner su crédito al día en las
							próximas horas, de esta manera evitara cargos adicionales, molestias
							innecesarias, así como el deterioro de su récord crediticio.
						</p>

						<p>
							Sin más a que referirnos, nos despedimos de usted a la espera de una
							respuesta pronta, a los <strong>{moment().format('DD')}</strong> días
							del mes de <strong>{moment().format('MMMM')}</strong> del año
							<strong> {moment().format('YYYY')}</strong>.
						</p>

						<p className="closing">Cordialmente.</p>

						<Stack direction="row" justifyContent="space-between">
							<Stack spacing={-3}>
								<p>Supervisión</p>
								<p>7664-0133</p>
							</Stack>

							<Stack spacing={-3}>
								<p>___________________________</p>
								<p>Recibido.</p>
							</Stack>
						</Stack>
					</div>
				</>
			)}
		</div>
	);
});

export default PrintNotificacionCobro;
